import { graphql } from "@opensea/graphql"
import { useCollectionOffersFragment } from "@/components/offers/use-collection-offers.fragment"

export const MobilePurchaseActionsFragment = graphql(
  `
    fragment MobilePurchaseActions on Collection {
      traitOffersEnabled
      ...useCollectionOffers
    }
  `,
  [useCollectionOffersFragment],
)
